import { LayoutGrid, List } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { TypeViewMode } from '@/libs/interfaces'
import { cn } from '@/libs/utils'

interface ViewSwitcherProps {
  viewMode: TypeViewMode
  onViewModeChange: (mode: TypeViewMode) => void
  className?: string
}

export function ViewSwitcher({ viewMode, onViewModeChange, className }: ViewSwitcherProps) {
  const { t } = useTranslation()

  return (
    <div className={cn('flex items-center gap-1 p-1 bg-muted rounded-lg', className)}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={viewMode === 'tabs' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('tabs')}
            className={cn(
              'h-7 px-2.5 gap-2 flex-1',
              viewMode === 'tabs' ? '' : 'hover:bg-background/50',
            )}
          >
            <LayoutGrid className="w-4 h-4" />
            <span className="hidden sm:inline">{t('common.viewMode.tabs')}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('tooltips.viewSwitcher.cards')}</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            className={cn(
              'h-7 px-2.5 gap-2 flex-1',
              viewMode === 'list' ? '' : 'hover:bg-background/50',
            )}
          >
            <List className="w-4 h-4" />
            <span className="hidden sm:inline">{t('common.viewMode.list')}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('tooltips.viewSwitcher.list')}</TooltipContent>
      </Tooltip>
    </div>
  )
}
